import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "form-label d-flex" }
const _hoisted_4 = { class: "form-check m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label me-3" }, "Секция", -1)
const _hoisted_6 = { class: "form-check m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label me-3" }, "Участок", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  key: 0,
  class: "12"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-sm",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.type) = $event)),
                  class: "form-check-input",
                  name: "1",
                  type: "radio",
                  value: 1
                }, null, 512), [
                  [_vModelRadio, _ctx.state.type]
                ]),
                _hoisted_5
              ]),
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.type) = $event)),
                  class: "form-check-input",
                  name: "2",
                  type: "radio",
                  value: 2
                }, null, 512), [
                  [_vModelRadio, _ctx.state.type]
                ]),
                _hoisted_7
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.state.type === 1)
              ? (_openBlock(), _createBlock(_component_form_group_ui, {
                  key: 0,
                  "invalid-feedback": "Укажите технику",
                  label: "Техника",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isSectionIdError,
                      options: _ctx.locos,
                      placeholder: "Техника",
                      searchable: true,
                      values: [_ctx.state.sectionId],
                      onOnSelected: _ctx.onSectionSelected
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.state.type === 2)
              ? (_openBlock(), _createBlock(_component_form_group_ui, {
                  key: 1,
                  "invalid-feedback": "Укажите участок",
                  label: "Участок",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isDepartmentIdError,
                      options: _ctx.departments,
                      placeholder: "Участок",
                      searchable: true,
                      values: [_ctx.state.departmentId],
                      onOnSelected: _ctx.onDepartmentSelected
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Укажите вид ремонта",
                  label: "Вид ремонта"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isJobCategoryIdError,
                      options: _ctx.jobs,
                      placeholder: "Вид ремонта",
                      searchable: true,
                      values: [_ctx.state.jobCategoryId],
                      onOnSelected: _ctx.onJobCategorySelected
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}